import { Component } from '@angular/core';
import { BaseViewComponent } from '../base-view.component';

@Component({
    selector: 'app-default',
    templateUrl: './default.component.html',
    styleUrl: './default.component.scss',
    standalone: false
})
export class DefaultComponent extends BaseViewComponent {

  protected override onSecureDataChanged(): void { }
}
